const FILE_VIEWER_PAYLOAD_KEY_PREFIX = 'file-viewer:payload:';

export type FileViewerPayload = {
  fileUrl: string;
  fileExtension: string;
  submissionContextId?: string;
  organizationId?: string;
};

export const createFileViewerRequest = (payload: FileViewerPayload): string => {
  const requestId = crypto.randomUUID();
  const requestStorageKey = `${FILE_VIEWER_PAYLOAD_KEY_PREFIX}${requestId}`;
  // Use localStorage so the opener can pass data to a new tab.
  // We keep it until explicitly cleared to support refresh.
  window.localStorage.setItem(requestStorageKey, JSON.stringify(payload));
  return requestId;
};

export const getFileViewerRequest = (
  requestId?: string | null
): FileViewerPayload | undefined => {
  if (!requestId) {
    return undefined;
  }

  const requestStorageKey = `${FILE_VIEWER_PAYLOAD_KEY_PREFIX}${requestId}`;
  const rawPayload = window.localStorage.getItem(requestStorageKey);

  if (!rawPayload) {
    return undefined;
  }

  try {
    return JSON.parse(rawPayload) as FileViewerPayload;
  } catch (_error) {
    return undefined;
  }
};

export const clearFileViewerRequest = (requestId?: string | null): void => {
  if (!requestId) {
    return;
  }

  const requestStorageKey = `${FILE_VIEWER_PAYLOAD_KEY_PREFIX}${requestId}`;
  window.localStorage.removeItem(requestStorageKey);
};
